// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__2clOB","icon":"MenuItem_icon__2uiTJ","label":"MenuItem_label__1_iDi","active":"MenuItem_active__2BATa"};